import React, { FC } from 'react';

import ConditionRow from './ConditionRow';

type SpamConditionProps = {
  index: number;
  onDelete: Function;
};

const SpamCondition: FC<SpamConditionProps> = ({ index, onDelete }) => {
  return <ConditionRow index={index} onDelete={onDelete} text="Email is flagged as spam" />;
};

export default SpamCondition;
